import { NullableString } from '../../../frontend-common-libs/src/common/nullable-types';
import { ReservationProtocol } from '../types';
import noneProtocolItem from '../noneProtocolItem';

export default function setJobToReservationProtocol(
  instrumentId: string,
  jobId: string,
  protocol: NullableString,
  reservationProtocol: string
): string {
  const reservationProtocolArray = JSON.parse(reservationProtocol) as ReservationProtocol[];
  const protocolName = protocol == null || protocol === '' ? noneProtocolItem.name : protocol;

  let instrumentFound = false;
  reservationProtocolArray.forEach((instrument, index) => {
    if (instrument.instrumentId === instrumentId) {
      instrumentFound = true;
      reservationProtocolArray[index].jobId = jobId;
      reservationProtocolArray[index].protocolName = protocolName;
    }
  });

  if (!instrumentFound) {
    reservationProtocolArray.push({
      instrumentId,
      jobId,
      protocolName
    });
  }

  return JSON.stringify(reservationProtocolArray);
}
